import React, { Component } from "react";
import { Link } from "react-router-dom";
const Navs = (props) => {
  return (
    <ul className="nav p-4">
      <h5>
        <li className="nav-item">
          <Link className="nav-link active lead text-dark " to="/">
            Movies
          </Link>
        </li>
      </h5>
      <li className="nav-item">
        <Link className="nav-link" to="/">
          Now Showing
        </Link>
      </li>
      <li className="nav-item">
        <Link className="nav-link" to="/">
          Coming Soon
        </Link>
      </li>
      <li className="nav-item">
        <Link className="nav-link " to="/">
          Exclusive
        </Link>
      </li>
    </ul>
  );
};

export default Navs;
